"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Callback = function () { return (React.createElement("div", { className: "oidc-callback" },
    React.createElement("div", { className: "oidc-callback__container" },
        React.createElement("h1", { className: "oidc-callback__title" }, "Authentification termin\u00E9e"),
        React.createElement("p", { className: "oidc-callback__content" }, "Vous allez \u00EAtre redirig\u00E9 sur votre application.")))); };
exports.default = Callback;
